/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../app/pages/admin/auth/logout.component';
import * as i2 from '@ngrx/store/src/store';
import * as i3 from '@angular/router';
const styles_LogoutComponent:any[] = ([] as any[]);
export const RenderType_LogoutComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_LogoutComponent,data:{}});
export function View_LogoutComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_LogoutComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'sd-logout',
      ([] as any[]),(null as any),(null as any),(null as any),View_LogoutComponent_0,
      RenderType_LogoutComponent)),i0.ɵdid(1,114688,(null as any),0,i1.LogoutComponent,
      [i2.Store,i3.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LogoutComponentNgFactory:i0.ComponentFactory<i1.LogoutComponent> = i0.ɵccf('sd-logout',
    i1.LogoutComponent,View_LogoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vYXV0aC9sb2dvdXQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vYXV0aC9sb2dvdXQuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvcXVhbmhvYW5nL3plbmlmeS9yZXBvcy9jbGllbnQtZmluYWwvc3JjL2FwcC9wYWdlcy9hZG1pbi9hdXRoL2xvZ291dC5jb21wb25lbnQudHMuTG9nb3V0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNkLWxvZ291dD48L3NkLWxvZ291dD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7Z0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/pages/admin/auth/logout.component.ngfactory.ts